import { Breadcrumb, Col, Divider, message, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { fetchUserGroupById } from '../../slices/user-group';

const ViewUserGroup = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [groupData, setGroupData] = useState(null);

  useEffect(() => {
    const fetchGroupData = async () => {
      try {
        dispatch(fetchUserGroupById(id))
          .unwrap()
          .then(response => {
            if (response) {
              setGroupData(response);
            }
          })
          .catch(error => {
            message.error(error?.detail);
          });
      } catch (error) {
        console.error('');
      }
    };

    fetchGroupData();
  }, [id]);

  return (
    <div>
      <div className='sticyaction'>
        <Row className="pagenamerow mb-0" justify="space-between" align="middle">
          <Col>
            <h2 style={{ margin: 0 }}>View User Group</h2>
            <div className="bredcrumbwrp">
              <Link to="/manage-user-group" className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/dashboard">Home</Link> },
                  { title: <Link to="/manage-user-group">Groups</Link> },
                  { title: 'View User Group' },
                ]}
              />
            </div>
          </Col>
          <Col>

          </Col>
        </Row>
      </div>
      <div className='formwrapper'>
      <Row gutter={[16, 16]} className="viewform">
        <Col xs={24} sm={12} lg={8} xl={6}>
          <label className="customlabel">Name</label>
          <div className="customvalue">{groupData?.name}</div>
        </Col>

      </Row>
   
      <div style={{ marginTop: '50px' }}>
        <h3>Permissions</h3>

      </div>

      <Divider />
      {groupData?.permissions.length === 0 ? (
        <p>No permissions available.</p>
      ) : (
        <ul>
          {groupData?.permissions.map((item) => (
            <li key={item.id}>
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
    </div>
  );
};

export default ViewUserGroup;
